import { CheckCircle, XCircle, Minus } from "@phosphor-icons/react";

export function vrioVerdict(p) {
  if (p.value === null || p.value === undefined) return { label: "Not yet assessed", cls: "bg-slate-100 text-slate-500 border-slate-200" };
  if (!p.value) return { label: "Competitive Disadvantage", cls: "bg-red-50 text-red-700 border-red-200" };
  if (!p.rarity) return { label: "Competitive Parity", cls: "bg-slate-100 text-slate-700 border-slate-300" };
  if (!p.inimitability) return { label: "Temporary Competitive Advantage", cls: "bg-amber-50 text-amber-700 border-amber-200" };
  if (!p.organization) return { label: "Temporary Competitive Advantage", cls: "bg-amber-50 text-amber-700 border-amber-200" };
  return { label: "Sustained Competitive Advantage", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" };
}

export const GATES = [
  { key: "value", title: "Value" },
  { key: "rarity", title: "Rarity" },
  { key: "inimitability", title: "Inimitability" },
  { key: "organization", title: "Organization" },
];

export default function VrioBlueprint({ doc }) {
  const p = doc.payload || {};
  const verdict = vrioVerdict(p);
  return (
    <div className="space-y-4" data-testid="vrio-blueprint">
      <div className="bg-white border border-slate-200 rounded-sm p-5">
        <p className="text-xs font-semibold tracking-[0.08em] uppercase text-slate-400 mb-1">Capability / Asset</p>
        <p className="text-base font-medium text-slate-900">{p.asset || <span className="text-slate-300">—</span>}</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {GATES.map((g) => {
          const val = p[g.key];
          return (
            <div key={g.key} data-testid={`vrio-gate-${g.key}`} className="bg-white border border-slate-200 rounded-sm p-4 text-center">
              <p className="text-xs font-semibold tracking-wide uppercase text-slate-500 mb-2">{g.title}</p>
              {val === true ? <CheckCircle size={28} weight="fill" className="text-emerald-500 mx-auto" /> : val === false ? <XCircle size={28} weight="fill" className="text-red-500 mx-auto" /> : <Minus size={28} className="text-slate-300 mx-auto" />}
              <p className={`mt-1 text-xs font-semibold ${val === true ? "text-emerald-700" : val === false ? "text-red-700" : "text-slate-400"}`}>{val === true ? "Yes" : val === false ? "No" : "—"}</p>
            </div>
          );
        })}
      </div>
      <div className={`rounded-sm border p-5 text-center ${verdict.cls}`} data-testid="vrio-verdict">
        <p className="text-xs font-mono uppercase tracking-[0.12em] opacity-70">Competitive Health</p>
        <p className="mt-1 text-xl font-bold tracking-tight">{verdict.label}</p>
      </div>
    </div>
  );
}
